export var source = "mutation SaveNetflixRecommendations($input: VoteFragranticaProductInput!) {\n  voteFragranticaProduct(input: $input) {\n    result\n  }\n}";
export default source;